import { LoadingSpinner } from '@/components/Generic'
import { observer } from 'mobx-react'
import { useContext, useEffect } from 'react'
import { StoreContext } from '@/store/Root.store'
import { MediaPermissionsChecker } from '@/components/MediaPermissionsChecker/MediaPermissionsChecker'
import { VideoIdAfterCancelPopup } from '@/components/VideoIdAfterCancelPopup/VideoIdAfterCancelPopup'
import { useVideoId } from '@/hooks/useVideoId/useVideoId'
import { AmexGreatLayout } from './AmexGreatLayout'

export const VideoIdAmexGreatPage = observer(() => {
  const store = useContext(StoreContext)
  const { userAgent } = store.AppState
  const { isMobile } = store.AppState
  const { VideoIdPage: trans } = store.TranslationsState.translations
  const { browser } = userAgent

  const {
    afterClosePopupVisible,
    isPermissionCheckSuccessful,
    setIsPermissionCheckSuccessful,
    handleClosePopup,
    shouldHideEidv,
  } = useVideoId({})

  useEffect(() => {
    if (isPermissionCheckSuccessful && browser === 'firefox') {
      document.body.classList.add('hide-video-id-modal')
    }

    return () => {
      document.body.classList.remove('hide-video-id-modal')
    }
  }, [])

  const renderVideoId = () =>
    isPermissionCheckSuccessful ? (
      <div className="themed-eidv-wrapper">
        <div id="video" />
      </div>
    ) : (
      <MediaPermissionsChecker onPermissionCheckEnd={setIsPermissionCheckSuccessful} />
    )

  if (shouldHideEidv) {
    return (
      <AmexGreatLayout>
        <div className="page-container mobile-m-10">
          <LoadingSpinner />
        </div>
      </AmexGreatLayout>
    )
  }

  if (isMobile) {
    return (
      <AmexGreatLayout>
        <>
          <VideoIdAfterCancelPopup
            title={trans.feedbackPopupTitle}
            thankYouForYourFeedback={trans.thankYouForYourFeedback}
            sendButtonText={trans.send}
            cancelButtonText={trans.close}
            visibility={afterClosePopupVisible}
            handleVisibility={handleClosePopup}
          />
          {renderVideoId()}
        </>
      </AmexGreatLayout>
    )
  }

  return (
    <AmexGreatLayout>
      <div className="page-container w-1000 mobile-m-0">
        <VideoIdAfterCancelPopup
          title={trans.feedbackPopupTitle}
          thankYouForYourFeedback={trans.thankYouForYourFeedback}
          sendButtonText={trans.send}
          cancelButtonText={trans.close}
          visibility={afterClosePopupVisible}
          handleVisibility={handleClosePopup}
        />
        {renderVideoId()}
      </div>
    </AmexGreatLayout>
  )
})
